// uppyInstance.js
import Uppy from "@uppy/core";
import Tus from "@uppy/tus";
import GoldenRetriever from "@uppy/golden-retriever";

const tusApi = process.env.REACT_APP_TUS_SERVER;
// console.log("server tusApi", tusApi);

let uppy = null;

const allowedExtensions = (process.env.REACT_APP_ALLOWED_EXTENSIONS || "").split(",");
// console.log(allowedExtensions);

export function createUppy(token, username) {
  if (uppy) return uppy;

  uppy = new Uppy({
    id: "uploader",
    autoProceed: false,
    restrictions: {
      maxNumberOfFiles: 10,
      allowedFileTypes: allowedExtensions
    },

  });

  uppy.use(GoldenRetriever, {
    allowedMetaFields: ["relativePath", "type", "filetype", "filename", "username"],
  });

  uppy.use(Tus, {
    endpoint: `${tusApi}/files`,
    retryDelays: [0, 1000, 3000, 5000],
    withCredentials: true,
    chunkSize: 800 * 1024,
    allowedMetaFields: ["relativePath", "type", "filetype", "filename", "username"],
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  uppy.on("file-added", (file) => {
    // Strict file type validation
    // const allowedExtensions = [
    //   "txt", "csv", "tsv",
    //   "doc", "docx",
    //   "xls", "xlsx",
    //   "ppt", "pptx",
    //   "xml", "html", "htm",
    //   "json", "md",
    //   "zip",
    //   "tar"
    // ];

    // const fileExt = file.name.split('.').pop()?.toLowerCase();
    // if (!fileExt || !allowedExtensions.includes(fileExt)) {
    //   uppy.removeFile(file.id);
    //   alert(`${file.name} is not allowed. Only raw text/docs/spreadsheets/presentations/zip files are accepted.`);
    //   return;
    // }

    // Set custom metadata
    uppy.setFileMeta(file.id, {
      relativePath: file.relativePath || "",
      type: file.type,
      filetype: file.type,
      filename: file.name,
      username,
    });
  });


  uppy.on("error", (error) => {
    console.error("Uppy error:", error);
    alert("Upload failed: " + error.message);
  });

  return uppy;
}

export function resetUppy() {
  if (uppy) {
    uppy.cancelAll();
    uppy.destroy();
    uppy = null;
  }
}
